import apiClient from '@/api/client';

export type ApprovalAction = 'approve' | 'reject' | 'request_changes';
export type ApprovalStatus = 'pending' | 'approved' | 'rejected' | 'changes_requested';

export interface ApprovalItem {
  id: string;
  entity_type: string;
  module: 'accounting' | 'hr' | 'budget' | 'purchasing' | 'other';
  /** "budget" = a budget / transfer / purchase step; decided via /budget/approvals/{id}/decide. */
  source?: 'budget' | 'budget_suggestion';
  entity_id: string;
  required_role: string;
  approval_order: number;
  status: ApprovalStatus;
  created_at: string | null;
  decided_by: string | null;
  decided_at: string | null;
  comments: string | null;
  entity_description: string;
  entity_amount: number | null;
  requester_name: string;
}

export interface ApprovalStats {
  pending: number;
}

export const approvalsApi = {
  pending: (entityType?: string) =>
    apiClient.get<ApprovalItem[]>('/approvals/pending', {
      params: entityType ? { entity_type: entityType } : {},
    }),
  history: (limit = 50) =>
    apiClient.get<ApprovalItem[]>('/approvals/history', { params: { limit } }),
  mySubmissions: (limit = 50) =>
    apiClient.get<ApprovalItem[]>('/approvals/my-submissions', { params: { limit } }),
  stats: () =>
    apiClient.get<ApprovalStats>('/approvals/stats'),
  decide: (approvalId: string, action: ApprovalAction, comments?: string) =>
    apiClient.post(`/approvals/${approvalId}/decide`, { action, comments }),
  resubmit: (approvalId: string) =>
    apiClient.post(`/approvals/${approvalId}/resubmit`),
};
